export default async function moveObj(moveParams){
    //console.log("moving object");
    await fetch('https://nmk8rxiom5.execute-api.us-east-1.amazonaws.com/deploy?operation=Move_S3object',{
      method: "POST",
      body: JSON.stringify(moveParams)
    })
    .then(response => response.json())
    .then(json => console.log(json))
    .catch(err => console.log(err));
}